import { useEffect, useMemo } from "react";
import { connect, useDispatch } from "react-redux";
import moment from "moment";

import {
  fetchPackageOrders,
  startAutoReload,
  stopAutoReload,
  clearPackageOrderList,
} from "actions/packageOrderList";
import { fetchPackageStockLocations } from "actions/packageStockLocations";
import $S from "theme/settings";
import { sortByGivenKeys } from "theme/utils";
import { fetchPackageStatuses } from "actions/packageStatuses";
import { fetchTransferStatuses } from "actions/transferStatuses";
import { fetchCurrentStaff } from "actions/staffs";

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

let _content = null;

const statusEnumMapping = {
  collecting: $S.packageOrderListCollectingStatusesToShow,
  packaging: $S.packageOrderListPackagingStatusesToShow,
  distribution: $S.packageOrderListDistributionStatusesToShow,
};

const PackageOrderList = (props) => {
  const {
    fetchPackageOrders,
    startAutoReload,
    stopAutoReload,
    clearPackageOrderList,
    fetchPackageStockLocations,
    location,
    packageStatuses,
    pendings: { pendingPackageStatuses, pendingPackageOrders },
    fetchCurrentStaff,
  } = props;

  const dispatch = useDispatch();
  const shownStatusEnumValues = useMemo(
    () =>
      packageStatuses.length > 0 ? decideShownStatuses() : { id: undefined },
    [pendingPackageStatuses, pendingPackageOrders]
  );

  useEffect(() => {
    const employeeId = localStorage.getItem("localCurrentStaff");
    if (employeeId) {
      dispatch(fetchPackageStatuses(employeeId));
    }

    fetchCurrentStaff();
  }, []);

  useEffect(() => {
    if (!$S.isPackageOrderListMobileView) {
      if ($S.packageOrderListAutoReload.active) {
        startAutoReload($S.packageOrderListAutoReload.ms);
      }
    } else {
      const { state: locationState = {} } = location;
      const { params = getDefaultParams() } = locationState;
      fetchPackageOrders(params);
    }

    return () => {
      if (
        !$S.isPackageOrderListMobileView &&
        $S.packageOrderListAutoReload.active
      ) {
        stopAutoReload();
      }
      clearPackageOrderList();
    };
  }, []);

  useEffect(() => {
    fetchPackageStockLocations();
    fetchTransferStatuses();
  }, []);

  const getDefaultParams = () => {
    let defaultParams = {};

    if ($S.hasPackageOrderListDeliveryRange) {
      defaultParams = {
        ...defaultParams,
        delivery_range_date: moment().format("YYYY-MM-DD"), // today
      };
    }
    return defaultParams;
  };

  function decideShownStatuses() {
    const {
      location: { pathname },
    } = props;

    const path = pathname.replace(`${$R.PACKAGE_ORDER_LIST.path}/`, "");
    const enum_value =
      statusEnumMapping[path] || $S.packageOrderListDefaultStatusesToShow;
    localStorage.setItem("localEnumValue", JSON.stringify(enum_value));
    return enum_value;
  }

  const getStatuses = () => {
    const { packageStockLocations, packageStatuses } = props;

    const statuses = packageStatuses
      .sort((a, b) => {
        if (a.enum_value === b.enum_value) return a.id - b.id;
        return a.enum_value - b.enum_value;
      })
      .map((item) => {
        const stockLocation = packageStockLocations.find(
          (state) =>
            parseInt(state.package__state__id, 10) === parseInt(item.id, 10)
        );
        return {
          ...item,
          package__count: stockLocation ? stockLocation.package__count : 0,
        };
      });

    const _statuses = sortByGivenKeys(
      statuses,
      shownStatusEnumValues,
      "enum_value"
    ).filter(({ enum_value }) => shownStatusEnumValues.includes(enum_value));

    return _statuses || [];
  };

  const filterPackageOrders = (params) => {
    const { history } = props;
    fetchPackageOrders(params);
    history.push({ state: { params } });
  };

  return (
    _content &&
    _content({
      props,
      shownStatusEnumValues,
      getDefaultParams,
      decideShownStatuses,
      getStatuses,
      filterPackageOrders,
    })
  );
};

const mapStateToProps = (state) => ({
  packageStatuses: state.packageStatuses.packageStatuses,
  pending: state.packageStatuses.pending,
  stockLocation: state.stockLocation.stockLocation,
  packageStockLocations: state.packageStockLocations.packageStockLocations,
  packageOrders: state.packageOrderList.packageOrders,
  packageOrderCount: state.packageOrderList.count,
  deliveryRanges: state.packageDeliveryRanges.deliveryRanges,
  pendings: {
    pendingPackageStatuses: state.packageStatuses.pending,
    pendingPackageOrders: state.packageOrderList.pending,
  },
  activeStatusId: state.packageOrderList.activeStatusId,
});

const mapDispatchToProps = {
  fetchPackageOrders,
  startAutoReload,
  stopAutoReload,
  clearPackageOrderList,
  fetchPackageStockLocations,
  fetchCurrentStaff,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(PackageOrderList);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/PackageOrderList/main/index.js